import React from 'react';
import classNames from 'classnames';
const $ = jQuery;

class MapSearch extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: '',
    };
    this.handleClick = this.handleClick.bind(this);
    this.handleMapData = this.handleMapData.bind(this);
  }
  componentDidMount() {
    const input = (document.getElementById('location'));
    const self = this;
    const autocomplete = new google.maps.places.Autocomplete(input);
    const geocoder = new google.maps.Geocoder();
    google.maps.event.addListener(autocomplete, 'place_changed', () => {
      const place = autocomplete.getPlace();
      if (place.geometry === undefined) {
        return;
      }
      geocoder.geocode({ latLng: place.geometry.location }, (responses) => {
        self.props.submitMapSearch(place.formatted_address);
      });
    });
  }
  componentWillReceiveProps(nextProps) {
    let value = '';
    if (nextProps.urlData.hasOwnProperty('location')) {
      for (let index = 0; index < nextProps.urlData['location'].length; index++) {
        if (nextProps.urlData['location'][index] === '-') {
          if (nextProps.urlData['location'][index + 1] === '-') {
            value += ', ';
            index++;
          } else {
            value += ' ';
          }
        } else {
          value += nextProps.urlData['location'][index];
        }
      }
    }
    this.setState({ value });
  }
  handleClick(e) {
    const value = $('#location').val();
    this.setState({ value });
    e.preventDefault();
  }
  handleMapData(e) {
    this.setState({ value: e.target.value });
  }
  render() {
    const childInputClass = classNames('input-container', this.props.isOpenElement);
    return (
      <div className={childInputClass}>
        <input type="text" name="location" value={this.state.value} onClick={this.handleClick} onChange={this.handleMapData} className="textbox reactive-input" id="location" onSelect={this.handleClick}/>
      </div>
    );
  }
}

MapSearch.propTypes = {
  'value': React.PropTypes.array,
  'options': React.PropTypes.array,
  'isOpenElement': React.PropTypes.string,
  'block': React.PropTypes.object,
};

export default MapSearch;



/** WEBPACK FOOTER **
 ** ./assets/src/frontend/element/mapsearch.js
 **/